import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../Axios';
import { toggleRewardModal } from 'reducers/UiReducer';
import { toggleRewardAllocationModal } from 'reducers/UiReducer';



const getAxiosConfig = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const getErrorMessage = (error) =>
  error.response && error.response.data.message
    ? error.response.data.message
    : error.message;

const RewardReducer = createSlice({
  name: 'reward',
  initialState: {
    success: false,



    // Reward states
    rewardLoading: false,
    rewardList: [],
    rewardError: null,

    // Reward states
    rewardAllocationLoading: false,
    rewardAllocationList: [],
    rewardAllocationError: null,

    
  },
  reducers: {

 

    // Reward actions
    createRewardRequest(state) {
      state.rewardLoading = true;
    },
    createRewardSuccess(state, action) {
      state.rewardLoading = false;
      // state.rewardList.push(action.payload);
    },
    createRewardFail(state, action) {
      state.rewardLoading = false;
      state.rewardError = action.payload;
    },
    updateRewardRequest(state) {
      state.rewardLoading = true;
    },
    updateRewardSuccess(state, action) {
      state.rewardLoading = false;

    },
    updateRewardFail(state, action) {
      state.rewardLoading = false;
      state.rewardError = action.payload;
    },
    getRewardListRequest(state) {
      state.rewardLoading = true;
    },

    getRewardListSuccess(state, action) {
      state.rewardLoading = false;
      state.rewardList = action.payload;
    },
    getRewardListFail(state, action) {
      state.rewardLoading = false;
      state.rewardError = action.payload;
    },
 getRewardAllocationListRequest(state) {
      state.rewardAllocationLoading = true;
    },
    
    getRewardAllocationListSuccess(state, action) {
      state.rewardAllocationLoading = false;
      state.rewardAllocationList = action.payload;
    },
    getRewardAllocationListFail(state, action) {
      state.rewardAllocationLoading = false;
      state.rewardAllocationError = action.payload;
    },


     // Reward actions
    createRewardAllocationRequest(state) {
      state.rewardLoading = true;
    },
    createRewardAllocationSuccess(state, action) {
      state.rewardLoading = false;
      // state.rewardList.push(action.payload);
    },
    createRewardAllocationFail(state, action) {
      state.rewardLoading = false;
      state.rewardError = action.payload;
    },


    deleteRewardRequest(state) {
      state.rewardLoading = true;
    },
    deleteRewardSuccess(state, action) {
      state.rewardLoading = false;

    },
    deleteRewardFail(state, action) {
      state.rewardLoading = false;
      state.rewardError = action.payload;
    },




  },
});

export const {





  
  // Reward actions
  createRewardRequest,
  createRewardSuccess,
  createRewardFail,
  updateRewardRequest,
  updateRewardSuccess,
  updateRewardFail,
  getRewardListRequest,
  getRewardListSuccess,
  getRewardListFail,

  getRewardAllocationListRequest,
  getRewardAllocationListSuccess,
  getRewardAllocationListFail,

  createRewardAllocationRequest,
  createRewardAllocationSuccess,
  createRewardAllocationFail,

  deleteRewardRequest,
  deleteRewardSuccess,
  deleteRewardFail,



  

} = RewardReducer.actions;







export const createRewardDispatch = (formData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    };

    dispatch(createRewardRequest());

    const { data } = await axiosInstance.post('/Rewards/CreateRewards', formData, config);

    if (data.status === 1) {
      dispatch(createRewardSuccess());
      dispatch(getRewardListDispatch({}, token)); // or pass appropriate filter object
      dispatch(toggleRewardModal(false));
    } else {
      dispatch(createRewardFail(data.message || 'Reward creation failed.'));
    }
  } catch (error) {
    dispatch(
      createRewardFail(error.response?.data?.message || error.message)
    );
  }
};



export const updateRewardDispatch = (formData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateRewardRequest());
    const { data } = await axiosInstance.post(`/Rewards/UpdateRewards`, formData, config);
    if (data.status === 1) {
      dispatch(updateRewardSuccess());
      dispatch(getRewardListDispatch(formData, token));
      dispatch(toggleRewardModal(false));
    }

  } catch (error) {
    dispatch(
      updateRewardFail(
        error.response?.data?.message || error.message
      )
    );
  }
};



export const getRewardListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getRewardListRequest());

    const { offset = 0, recordcount = 10, fullName = '' } = form;

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      recordcount: recordcount.toString(),
      FullName: fullName
    });

    const { data } = await axiosInstance.get(
      `/Rewards/GetRewardsList?${queryParams.toString()}`,
      getAxiosConfig(token)
    );

    dispatch(getRewardListSuccess(data));
  } catch (error) {
    dispatch(getRewardListFail(getErrorMessage(error)));
  }
};




export const deleteRewardDispatch = (RewardId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteRewardRequest());
    await axiosInstance.delete(`/reward/DeleteRewardById/${RewardId}`, config);
    dispatch(deleteRewardSuccess());
  } catch (error) {
    dispatch(
      deleteRewardFail(
        error.response?.data?.message || error.message
      )
    );
  }
};


export const getRewardAllocationListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getRewardAllocationListRequest());

    const { offset = 0, recordcount = 20, partnerId = 0 } = form;

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      recordcount: recordcount.toString(),
      partnerId: partnerId,
      rewardId: 0,

    });

    const { data } = await axiosInstance.get(
      `/Rewards/PartnerRewardAllocationList?${queryParams.toString()}`,
      getAxiosConfig(token)
    );

    dispatch(getRewardAllocationListSuccess(data));
  } catch (error) {
    dispatch(getRewardAllocationListFail(getErrorMessage(error)));
  }
};

export const createRewardAllocationDispatch = (formData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    dispatch(createRewardAllocationRequest());

    const { data } = await axiosInstance.post('/Rewards/PartnerRewardAllocation', formData, config);

    if (data.status === 1) {
      dispatch(createRewardSuccess());
      dispatch(getRewardAllocationListDispatch({}, token)); // or pass appropriate filter object
      dispatch(toggleRewardAllocationModal(false));
    } else {
      dispatch(createRewardAllocationFail(data.message || 'Reward Allocation  failed.'));
    }
  } catch (error) {
    dispatch(
      createRewardAllocationFail(error.response?.data?.message || error.message)
    );
  }
};


export default RewardReducer;
